<template>
  <div class="mt-4">
    <h1 class="mb-4 text-center">Einstellungen</h1>
    <b-row class="g-3">
      <b-col cols="6" md="4" lg="2">
        <b-card class="tile text-center" @click="navigateTo('general')">
          <b-icon icon="person-circle" variant="danger" font-scale="2"></b-icon>
          <h5 class="mt-2">Konto</h5>
        </b-card>
      </b-col>

      <b-col cols="6" md="4" lg="2">
        <b-card class="tile text-center" @click="navigateTo('security')">
          <b-icon icon="key" variant="danger" font-scale="2"></b-icon>
          <h5 class="mt-2">Sicherheit</h5>
        </b-card>
      </b-col>

      <b-col cols="6" md="4" lg="2">
        <b-card class="tile text-center" @click="handleLogout()">
          <b-icon
            icon="box-arrow-left"
            variant="secondary"
            font-scale="2"
          ></b-icon>
          <h5 class="mt-2">Logout</h5>
        </b-card>
      </b-col>

      <b-col cols="6" md="4" lg="2">
        <a href="mailto:support@sfce-vereinsplattform.org" class="no-styles">
          <b-card class="tile text-center">
            <b-icon
              icon="question-circle"
              variant="secondary"
              font-scale="2"
            ></b-icon>
            <h5 class="mt-2">Support</h5>
          </b-card>
        </a>
      </b-col>

      <b-col v-if="isAdmin()" cols="6" md="4" lg="2">
        <b-card
          class="tile text-center"
          @click="navigateTo('admin')"
        >
          <b-icon
            icon="file-earmark-lock"
            variant="danger"
            font-scale="2"
          ></b-icon>
          <h5 class="mt-2">Administration</h5>
        </b-card>
      </b-col>

      <b-col v-if="!isStandalone" cols="6" md="4" lg="2">
        <b-card
          class="tile text-center"
          @click="handleInstall"
        >
          <b-icon icon="download" variant="danger" font-scale="2"></b-icon>
          <h5 class="mt-2">App installieren</h5>
        </b-card>
      </b-col>

      <div v-if="showIosHint" class="ios-install-hint text-center">
        <ol>
          <li>Öffne das Teilen-Menü in Safari 📤</li>
          <li>Wähle <strong>„Zum Home-Bildschirm“</strong></li>
          <li>Tippe auf <strong>„Hinzufügen“</strong></li>
        </ol>
        <button @click="showIosHint = false" class="close-btn">✖</button>
      </div>
    </b-row>
  </div>
</template>

<script>
import { logout } from "@/services/auth";

//import axios from "axios";

export default {
  name: "accountView",
  components: {},
  data() {
    return {
      deferredPrompt: null,
      isiOS: false,
      isStandalone: false,
      showIosHint: false,
    };
  },

  methods: {
    handleInstall() {
      if (this.isiOS) {
        // Show the iOS install hint instead
        this.showIosHint = true;
      } else if (this.deferredPrompt) {
        // Trigger the Android/Chrome install prompt
        this.deferredPrompt.prompt();
        this.deferredPrompt.userChoice.then(() => {
          this.deferredPrompt = null;
        });
      }
    },

    navigateTo(page) {
      this.$router.push(`/account/${page}`);
    },

    async handleLogout() {
      try {
        await logout();
        this.$router.push("/login");
      } catch (error) {
        console.log(error);
      }
    },

    isAdmin() {
      const roles = localStorage.getItem("roles");
      return roles.includes("ROLE_ADMIN");
    },
  },

  mounted() {
    // Check if the app is already installed
    this.isStandalone =
      window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone;

    // Detect if it's iOS
    const userAgent = window.navigator.userAgent.toLowerCase();
    this.isiOS = /iphone|ipad|ipod/.test(userAgent);

    // Handle Android/Chrome install prompt
    window.addEventListener("beforeinstallprompt", (event) => {
      event.preventDefault();
      this.deferredPrompt = event;
    });
  },
};
</script>

<style scoped>
h1 {
  text-align: center;
}

.tile {
  padding-top: 15%;
  height: 150px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
  cursor: pointer;
  border-radius: 10px;
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
}

.tile:hover {
  transform: scale(1.05);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

b-icon {
  margin-bottom: 8px;
}

h5 {
  font-size: 1rem;
  font-weight: bold;
  margin: 0;
  color: #333;
}

.no-styles {
  text-decoration: none !important;
  color: inherit !important;
}

.ios-install-hint {
  margin-top: 10px;
  font-size: 14px;
  color: #666;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  background: #f9f9f9;
  position: fixed;
  bottom: 7rem;
  left: 50%;
  transform: translateX(-50%);
  padding: 10px 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  z-index: 1000;
}
.close-btn {
  background: none;
  border: none;
  font-size: 16px;
  cursor: pointer;
  color: #666;
}
</style>
